import type {ReactElement} from 'react';
import {ThemeTile} from '@Components/ai-chat-window/components/change-style-dropdown/components/theme-tile/theme-tile';
import {CHANGE_STYLE_THEME_OPTIONS} from '@Components/ai-chat-window/components/change-style-dropdown/change-style-dropdown.library';
import type {ThemeGridProps} from './theme-grid.types';
import styles from './theme-grid.module.scss';

export function ThemeGrid({onThemeSelect, selectedTheme = null}: ThemeGridProps): ReactElement {
  return (
    <div className={styles.grid}>
      {CHANGE_STYLE_THEME_OPTIONS.map((option) => (
        <ThemeTile key={option.theme} option={option} onSelect={onThemeSelect} isSelected={option.theme === selectedTheme} />
      ))}
    </div>
  );
}
